import { 
	createSlice,
	createAsyncThunk
} from '@reduxjs/toolkit'
import { envAwarePost } from '../../util/util'

export const createProgressPicture = createAsyncThunk(
	'createProgressPicture',
	async payload => envAwarePost('api/pictures/',{
		action:'createProgressPicture',
		...payload
	})
)

const viewPicturesSlice = createSlice({
	name: 'viewPictures',
	initialState:{
        newPicId: {}
    },
	reducers: {},
	extraReducers:{

		[createProgressPicture.fulfilled] : (state,action)=>{
            state.newPicId = action.payload.picID
		},
	}
})


export default viewPicturesSlice.reducer